import React from 'react';
import './ExpandedFundAgreementTypeHeader.scss';
import { agreementTypeToDisplay } from '../../../../utils/funds/funds-utility';
import { Fund } from 'src/components/Exchange/types';

export type ExpandedFundAgreementTypeHeaderProps = Pick<
  Fund,
  'agreementType' | 'productType' | 'formattedEntityNames'
>;

const ExpandedFundAgreementTypeHeader: React.VFC<
  ExpandedFundAgreementTypeHeaderProps
> = ({ agreementType, formattedEntityNames, productType }) => (
  <div
    className={`fund-group-header e2e-${productType} expanded-fund-agreement-type-header-agreement-bar`}
  >
    <div>{agreementTypeToDisplay(agreementType)}</div>
    <div className="formatted-entity-names-header blocked_data">
      {formattedEntityNames}
    </div>
  </div>
);

export default ExpandedFundAgreementTypeHeader;
